import cf from './cf';
import c10v from './c10v_20211024';

export default class c10v1a extends c10v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = { // スタッフメンバ
      class: 'c10v1a',
      name: 'スタッフ登録',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
